import GiftCardViewController from './GiftCardViewController';

export default GiftCardViewController;